/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Incode_PlaceholderInputs */

const en_new_project_incode_placeholder = /** @type {(inputs: New_Project_Incode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const fr_new_project_incode_placeholder = /** @type {(inputs: New_Project_Incode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const de_new_project_incode_placeholder = /** @type {(inputs: New_Project_Incode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const it_new_project_incode_placeholder = /** @type {(inputs: New_Project_Incode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const ru_new_project_incode_placeholder = /** @type {(inputs: New_Project_Incode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const es_new_project_incode_placeholder = /** @type {(inputs: New_Project_Incode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const zh_cn2_new_project_incode_placeholder = /** @type {(inputs: New_Project_Incode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const ja_new_project_incode_placeholder = /** @type {(inputs: New_Project_Incode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const hi_new_project_incode_placeholder = /** @type {(inputs: New_Project_Incode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const pt_pt2_new_project_incode_placeholder = /** @type {(inputs: New_Project_Incode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

/**
* | output |
* | --- |
* | "00:00:00:00" |
*
* @param {New_Project_Incode_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_incode_placeholder = /** @type {((inputs?: New_Project_Incode_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Incode_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_incode_placeholder(inputs)
	if (locale === "de") return de_new_project_incode_placeholder(inputs)
	if (locale === "it") return it_new_project_incode_placeholder(inputs)
	if (locale === "ru") return ru_new_project_incode_placeholder(inputs)
	if (locale === "es") return es_new_project_incode_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_incode_placeholder(inputs)
	if (locale === "ja") return ja_new_project_incode_placeholder(inputs)
	if (locale === "hi") return hi_new_project_incode_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_incode_placeholder(inputs)
	return en_new_project_incode_placeholder(inputs)
});